export enum AccountErrorType {
  WRONG_BILL_TO_ACCOUNT = 'Wrong Bill-to Account Number',
  WRONG_SHIP_TO_ACCOUNT = 'Wrong Ship-to Account Number',
  WRONG_SOLD_TO_ACCOUNT = 'Wrong Sold-to Account Number',
}
